module.exports = __webpack_public_path__ + "static/img/wlx-cer-img.47e6f542.png";